<template>
  <div>
    <ul class="list-group">
      <!-- eslint-disable-next-line -->
        <li v-for="(competitor, index) in results"
          :key="index"
          class="list-group-item"
          @click="selectedList === index ? (selectedList = null) : (selectedList = index)"
      >
        <div class="list-group-row">
          <p class="mb-0">
            <b class="text-center text-primary mr-2 ml-1 place-number">{{
              competitor.position
            }}</b>
          </p>
          <div class="list-group-row-collapse">
            <div class="d-flex">
              <b>{{ competitor.domain }}</b>
              <div v-if="competitor.host === url">
                <span class="your-site-label">Your Site</span><br>
              </div>
            </div>
            <p
              class="mb-0 truncate"
            >
              {{ competitor.url }}
            </p>
          </div>
          <i
            class="fa fa-chevron-down open-list"
            aria-hidden="true"
          />
        </div>
        <div
          class="list-dropdown bg-white border-top-none"
          :class="selectedList === index ? 'active' : ''"
        >
          <ul
            v-if="hasAdditionalData(competitor)"
            class="pl-1 mt-1 mb-1"
          >
            <li>
              <b>URL:</b> <a
                class="text-nowrap"
                :href="competitor.url"
              > {{ competitor.url }} </a>
            </li>
            <li><b>Content:</b> {{ additionalData(competitor).domain.content_count }} words</li>
            <li><b>Backlinks:</b> {{ additionalData(competitor).domain.backlinks }} </li>
            <li><b>Domain Age:</b> {{ humanise(additionalData(competitor).domain.age) }} </li>
            <li><b>Time to load:</b> {{ formatTimeToLoad(additionalData(competitor).domain.time_to_load) }} </li>
            <li v-if="keywords[competitor.key].sv">
              <b>Search Volume:</b> {{ keywords[competitor.key].sv }}
            </li>
            <li v-if="keywords[competitor.key].cpc">
              <b>CPC:</b> ${{ keywords[competitor.key].cpc.toFixed(2) }}
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
  // TODO: Need to optimize this file and split to Row
  props: {
    results: {
      type: Array,
      required: true
    },
    selectedKeyword: {
      type: String
    },
  },

  data() {
    return {
      selectedList: null,
    }
  },

  computed:{
    ...mapState('app', ['url','competitorErrors']),
    ...mapState('keyword', ['additionalResults', 'keywords']),
  },

  methods: {
    hasAdditionalData(item) {
      return this.additionalResults.hasOwnProperty(item.uuid)
    },

    additionalData(item) {
      return this.additionalResults[item.uuid];
    },

    formatTimeToLoad(seconds) {
      return `${seconds/100}s`
    }
  }

}
</script>

<style lang="scss" scoped>
  .list-group-item {
    .place-number {
      font-size: 21px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }
    .open-list {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      width: 10%;
      background-color: #fff;
      padding: 0px 10px;
    }
  }
  .list-group-row {
    display: flex;
    width: 100%;
    align-items: center;
  }
  .list-group-row-collapse {
    overflow: hidden;
    padding: 5px;
    min-width: 0;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .list-dropdown {
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    display: none;
    &.active {
      display: block;
      border-radius: 5px;
      overflow: hidden;
    }
    li {
      list-style: none;
    }
  }
  .my-website-list {
    box-shadow: 0 4px 7px rgba(182, 182, 182, 0.9);
    background-image: linear-gradient(270deg, #3caef3 0%, #266ce7 100%);
    border-left: 0 solid white;
    border-right: 0 solid white;
    p,
    a,
    .open-list,
    .place-number {
      /*eslint-disable-next-line*/
      color: #fff !important;
    }
    li:last-child {
      padding-bottom: 1rem;
    }
  }

  .your-site-label {
    color: #ffffff;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    box-shadow: 0 2px 14px rgba(0, 0, 0, 0.2);
    background-image: linear-gradient(270deg, #fe5c07 0%, #ff943a 100%);
    padding: 3px;
  }
  .border-top-none {
    border-top: none;
  }
</style>
